import Modifier from "../Modifier";

class IndexModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        //this.index = index;
        this.name = 'index';
        this.index = parameters.index;
    }

    compute(data) {
        let that = this;

        let time = data.find(function (point) {
            return point.time === that.index;
        });

        if (time === undefined) {
            return [];
        }

        let divider = time.value;

        if (divider === 0) {
            return [];
        }

        return data.map(function (point) {
            point.value /= divider;
            return point;
        });
    }

}

export default IndexModifier;
